import React, { useEffect, useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const i18nPrefix = 'ConsentWall';

type ConsentWallProps = {
  onAccept: (permanent: boolean) => void;
};

const ConsentWall: React.FC<ConsentWallProps> = ({ onAccept }) => {
  const { t } = useTranslation();
  const [permanentConsent, setPermanentConsent] = useState(false);

  useEffect(() => {
    const storedConsent = localStorage.getItem('googleMapsCookiesAccepted');
    if (storedConsent === 'true') {
      onAccept(true);
    }
  }, [onAccept]);

  const handleAccept = () => {
    if (permanentConsent) {
      localStorage.setItem('googleMapsCookiesAccepted', 'true');
    }
    onAccept(permanentConsent);
  };

  return (
    <div
      className='d-flex justify-content-center align-items-center'
      style={{ minHeight: '50vh' }}>
      <Card style={{ maxWidth: '500px', width: '100%' }}>
        <Card.Body>
          <Card.Title>{t(`${i18nPrefix}.cardTitle`)}</Card.Title>
          <Card.Text>{t(`${i18nPrefix}.cardText`)}</Card.Text>
          <Form.Check
            id='permanentConsentCheckbox'
            type='checkbox'
            label={
              <label htmlFor='permanentConsentCheckbox' className='mb-0'>
                {t(`${i18nPrefix}.permanentConsentLabel`)}
              </label>
            }
            checked={permanentConsent}
            onChange={(e) => setPermanentConsent(e.target.checked)}
            className='mb-3'
          />
          <Button variant='primary' onClick={handleAccept}>
            {t(`${i18nPrefix}.acceptButton`)}
          </Button>
        </Card.Body>
      </Card>
    </div>
  );
};

export default ConsentWall;
